import React from 'react';
import { RadioChangeEvent } from 'antd';
import RadioGroup from '@ui-library/radio';
import { Caption, Subtext } from '@ui-library/typography';
import enableFeature, { Feature } from '@utils/enableFeature';
import classes from './genericSettings.module.scss';

export enum ScheduleTypes {
  Manual = 'manual',
  Basic = 'basic',
  Cron = 'cron',
}
export interface ScheduleSelectProps {
  scheduleType?: string;
  onScheduleTypeChange: (value: ScheduleTypes) => void;
}

const ScheduleSelect: React.FC<ScheduleSelectProps> = ({
  scheduleType,
  onScheduleTypeChange,
}: ScheduleSelectProps) => {
  const radioOnChange = (e: RadioChangeEvent) => {
    onScheduleTypeChange(e.target.value);
  };
  const isEnabled = enableFeature();
  const options = [
    { name: 'Basic', id: 'basic', description: 'Run syncs on a set interval.' },
    { name: 'Manual', id: 'manual', description: 'Run syncs manually.' },
  ];
  if (isEnabled(Feature.cronScheduling)) {
    options.splice(1, 0, {
      name: 'Cron',
      id: 'cron',
      description: 'Run syncs based on cron expression.',
    });
  }
  return (
    <RadioGroup
      onChange={radioOnChange}
      className={classes.schedule_types}
      value={scheduleType}
      items={options.map((option) => {
        const element = (
          <>
            <Subtext>{option.name}</Subtext>
            <Caption>{option.description}</Caption>
          </>
        );
        return {
          id: option.id,
          element,
          className: `${classes.item} ${scheduleType === option.id ? classes.selected : ''}`,
        };
      })}
    />
  );
};

export default ScheduleSelect;
